module.exports = __webpack_public_path__ + "static/media/Energy.222cf199.svg";